import { query, where } from 'firebase/firestore';
import { IFileBatch } from '../sp-types';
import { deleteItem, getItems, saveItem, updateItem } from './genericFB';

const COLLECTION_NAME = 'file-batches';

export async function getAccountFileBatches(accountId: string): Promise<IFileBatch[] | undefined> {
  return await getItems<IFileBatch>(accountId, COLLECTION_NAME);
}

export async function getSentFileBatches(accountId: string): Promise<IFileBatch[] | undefined> {
  return await getItems<IFileBatch>(accountId, COLLECTION_NAME, (q) =>
    query(q, where('status', 'in', ['pending', 'edit', 'done'])),
  );
}

export async function saveFileBatch(fileBatch: IFileBatch): Promise<IFileBatch | null> {
  return await saveItem<IFileBatch>(`${fileBatch.accountId}__${fileBatch.id}`, fileBatch, COLLECTION_NAME);
}

export async function deleteFileBatch(accountId: string, batchId: string): Promise<undefined> {
  return await deleteItem(`${accountId}__${batchId}`, COLLECTION_NAME);
}

export async function updateFileBatch(accountId: string, batchId: string, data: any): Promise<IFileBatch | null> {
  return await updateItem<IFileBatch>(`${accountId}__${batchId}`, data, COLLECTION_NAME);
}
